import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447716 2 1 2H19C19.5523 2 20 1.55228 20 1C20 0.447715 19.5523 0 19 0H1Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 8C0 7.44771 0.447715 7 1 7H19C19.5523 7 20 7.44771 20 8C20 8.55229 19.5523 9 19 9H1C0.447716 9 0 8.55229 0 8Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 15C0 14.4477 0.447715 14 1 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H1C0.447716 16 0 15.5523 0 15Z",
			fill: "#1A1A1A"
		})
	]
});
export default SvgIconMenu;
